<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="新建"
      width="600px"
      append-to-body
      @close="$reset('form')">
    <el-form 
        ref="form" 
        :model="model" 
        :rules="ruleValidate" 
        class="form" 
        label-width="80px">
      <el-form-item label="所属区域" prop="districtId">
        <el-cascader
            v-model="model.districtId"
            :options="options"
            style="width: 100%"
            placeholder="请选择所属区域"
            filterable/>
      </el-form-item>
      <el-form-item label="详细地址" prop="addressDetail">
        <el-input v-model="model.addressDetail" placeholder="请输入详细地址"/>
      </el-form-item>
      <el-form-item label="联系人" prop="contact">
        <el-input v-model="model.contact" placeholder="请输入联系人姓名"/>
      </el-form-item>
      <el-form-item label="联系方式" prop="telephone">
        <el-input v-model="model.telephone" placeholder="请输入联系方式"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleOk">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      options: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },

    data() {
      return {
        dialogVisible: false,
        model: {
          districtId: "",
          addressDetail: "",
          contact: "",
          telephone: "",
        },
        ruleValidate: {
          districtId: { required: true, message: "请选择所属区域", trigger: "change" },
          addressDetail: { required: true, message: "请输入详细地址", trigger: "blur" },
        },
      };
    },

    methods: {
      open() {
        this.dialogVisible = true;
      },

      handleOk() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.model.districtId = JSON.stringify(this.model.districtId);
            this.$emit("save-success", JSON.stringify(this.model));
            this.dialogVisible = false;
          }
        });
      },
    },
  };
</script>
